export default __webpack_public_path__ + "static/media/nWithd.5624be1d.svg";